import { TableContentSupplierDairySummaryReport, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;

        return (
            <div>
                <h3><center><u>Supplier Dairy Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <table id="totalCropPdf">
                    <thead>
                        <tr>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Welfare Society</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Supplier Name</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Supplier Reg No</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Weight</th>
                        </tr>
                    </thead>
                    <tbody>
                        <TableContentSupplierDairySummaryReport
                            data={data}
                            contentRowNames={rowNames}
                            hasEdit={false}
                        />
                    </tbody>
                    <tfoot>
                        <tr>
                            <th style={{ fontWeight: "bold" }} colSpan="1">Total</th>
                            <th></th>
                            <th></th>
                            <th style={{ textAlign: "right", fontWeight: "bold" }}>{totalRow.toFixed(2)}</th>
                        </tr>
                    </tfoot>
                </table>
                <hr />
            </div>
        );
    }
}